module.exports = __webpack_public_path__ + "img/F.115c2d56.png";